import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'p-stepper-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './p-stepper-header.component.html',
  styleUrl: './p-stepper-header.component.scss',
})
export class PStepperHeaderComponent {
  @Input() steps: string[] = [];
  @Input() currentStepIndex = 0;

  widthProgresBar = 0;

  ngOnChanges(): void {
    this.updateProgressBar();
  }

  private updateProgressBar(): void {
    if (!this.steps || this.steps.length <= 1) {
      this.widthProgresBar = 0;
      return;
    }

    const totalSteps = this.steps.length - 1;
    this.widthProgresBar = (this.currentStepIndex / totalSteps) * 100;
  }
}
